export const initialState = {  
  selectedCustomers: {},
  selectedOwners: {},
  selectedParentTypeKeys: {},
  selectedParentNames: {},
  selectedSurveyTypes: {},
};

export default { initialState };
